import { InlineTagSelector } from '../../crm/components/InlineTagSelector';
import { normalizeTags } from '../../utils/tags';

export function CanvasTagChips({
  tags,
  max = 2,
  variant = 'onGreen',
  className = '',
}) {
  const items = normalizeTags(tags);
  if (items.length === 0) return null;

  const visible = items.slice(0, max);
  const extra = items.length - visible.length;
  const onGreen = variant === 'onGreen';

  return (
    <div
      className={`flex flex-row items-center gap-1 min-w-0 flex-wrap ${className}`}
    >
      {visible.map((tag) => (
        <span
          key={tag.id ?? tag.name}
          title={tag.name}
          className={`inline-flex max-w-[72px] truncate rounded px-1.5 py-0.5 text-[10px] font-medium leading-tight ${
            tag.color
              ? ''
              : onGreen
                ? 'bg-white/20 text-white'
                : 'bg-black/5 text-text-muted'
          }`}
          style={
            tag.color
              ? {
                  backgroundColor: onGreen
                    ? `${tag.color}40`
                    : `${tag.color}15`,
                  color: onGreen ? '#FFFFFF' : tag.color,
                }
              : undefined
          }
        >
          {tag.name}
        </span>
      ))}
      {extra > 0 && (
        <span
          title={items
            .slice(max)
            .map((tag) => tag.name)
            .join(', ')}
          className={`inline-flex rounded px-1.5 py-0.5 text-[10px] font-medium leading-tight ${
            onGreen ? 'bg-white/20 text-white' : 'bg-black/5 text-text-muted'
          }`}
        >
          +{extra}
        </span>
      )}
    </div>
  );
}

export function InternalTagPicker({
  companyId,
  tags = [],
  disabled = false,
  onChange,
  instanceId,
  label = 'Internal tags',
  helperText,
  compact = false,
}) {
  return (
    <div className={`text-left min-w-0 ${compact ? 'space-y-1' : 'space-y-2'}`}>
      <label
        className={`block font-medium text-text-secondary ${compact ? 'text-sm' : 'text-xs'}`}
      >
        {label}
      </label>
      <InlineTagSelector
        companyId={companyId}
        instanceId={instanceId}
        tags={tags}
        localOnly
        disabled={disabled || !companyId}
        emptyLabel="No internal tags"
        placeholder="No internal tags"
        onTagsChange={(items) => {
          onChange?.({
            tags: items,
            tag_ids: items
              .map((tag) => Number(tag.id))
              .filter((id) => !Number.isNaN(id)),
          });
        }}
      />
      {helperText ? (
        <p className="text-xs leading-snug text-text-muted">{helperText}</p>
      ) : null}
    </div>
  );
}
